import React, {useEffect, useState} from 'react';
import {GlobalNav, setGlobalNavUri} from '@snsw/react-global-nav';
import {ComponentLoader} from '@snsw-gel/react';
import {GlobalNavLinks} from './GlobalNavLinks';
import {GlobalNavConfig} from './GlobalNavConfig';
import {useApplicationConfig} from '@gaas/gaas-react-component-library';

/** A wrapper around the global nav. Stolen from gaas repo. */
export const GlobalNavWrapper = (props: { children: any; }) => {
    const config = useApplicationConfig();
    const globalNavConfig: GlobalNavConfig = config.appConfig.globalNavConfig;
    const [ready, setReady] = useState(false);

    useEffect(() => {
        try {
            setGlobalNavUri(
                globalNavConfig.globalNavUrl,
                {'x-api-key': globalNavConfig.globalNavUrlApiKey},
            );
        } catch (e) {
            console.error(`Error loading global nav: ${e}`);
        }
        setReady(true);
    }, [globalNavConfig]);
    return ready ?
        <GlobalNav
            accountNavLinks={<GlobalNavLinks appConfig={globalNavConfig}/>}
            translation={false}
        >
            {props.children}
        </GlobalNav> :
        <ComponentLoader
            active={!ready}
            label='One moment, please...'
        />;
};
